export default function flatObject(
  object: Record<string, string> | Array<any>,
): Record<string, string> {
  const result: Record<string, string> = {};
  for (const key in object) {
    const value = object[key];

    if (typeof value === "object") {
      const subResult = flatObject(value);
      for (const subKey in subResult) {
        result[`${key}.${subKey}`] = subResult[subKey];
      }
    } else {
      result[key] = value;
    }
  }

  return result;
}
